



















/* ----------------------------------------
    Imports
---------------------------------------- */

import { Component, Vue } from 'vue-property-decorator';

/* ----------------------------------------
     Mixin
 ---------------------------------------- */

import BlockMixin from '@mixin/blocks';

/* ----------------------------------------
    Component
---------------------------------------- */

@Component({

    mixins: [
        BlockMixin
    ],

    computed: {
        closed() {
            return this.options.closed ? 'collage-block--closed' : ''
        }
    },

    customReveal: true,

    reveal: (el, transition) => {
        transition.collageReveal(el);
    },

})

/* ----------------------------------------
    Export
---------------------------------------- */

export default class CollageBlock extends Vue {}

